import { Invoice } from './invoice';

/**
 * Slim model for the V2 invoice list endpoint (`api/v2/invoice-list`).
 *
 * Phase 1 returns only the simple fields. Extending {@link Invoice} keeps the
 * existing list/component typing working while the V2 backend is fleshed out
 * in subsequent phases.
 */
export class InvoiceListItem extends Invoice {}
